    // Product Data
    const productData = {
        title: 'INHALE BLEND ESSENTIAL OIL',
        variant: 'Essential Oil',
        price: '15.00',
        variantId: '49772571033846',
        quantity: 1,
        image: 'https://cdn.shopify.com/s/files/1/0773/7756/9014/files/E76C9C0D-C753-4120-B9B4-606354352D09.jpg?v=1764927011'
    };

    let currentQuantity = 1;

    // ===== COUNTDOWN TIMER FUNCTION =====
    // Starts at 14 days, loops back to 14 when it hits 0
    let countdownInterval;
    let totalSeconds = 14 * 24 * 60 * 60; // 14 days in seconds

    function updateCountdownDisplay() {
        const days = Math.floor(totalSeconds / (24 * 60 * 60));
        const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;

        const daysElement = document.getElementById('countdownDays');
        const hoursElement = document.getElementById('countdownHours');
        const minutesElement = document.getElementById('countdownMinutes');
        const secondsElement = document.getElementById('countdownSeconds');

        if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
        if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
        if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
        if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
    }

    function startCountdown() {
        if (countdownInterval) clearInterval(countdownInterval);
        
        countdownInterval = setInterval(() => {
            if (totalSeconds <= 0) {
                // Loop back to 14 days when it hits 0
                totalSeconds = 14 * 24 * 60 * 60;
                updateCountdownDisplay();
            } else {
                totalSeconds--;
                updateCountdownDisplay();
            }
        }, 1000);
    }

    function initCollapsibles() {
        const collapsibles = document.querySelectorAll('.collapsible-item');

        collapsibles.forEach(coll => {
            const header = coll.querySelector('.collapsible-header');
            const content = coll.querySelector('.collapsible-content');
            const icon = header ? header.querySelector('.collapsible-icon') : null;

            if (!header || !content || !icon) return;

            header.setAttribute('role', 'button');
            header.setAttribute('tabindex', '0');
            header.setAttribute('aria-expanded', 'false');

            const toggle = () => {
                const isOpen = content.classList.contains('open');
                content.classList.toggle('open', !isOpen);
                icon.textContent = isOpen ? '+' : '−';
                icon.classList.toggle('open', !isOpen);
                header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            };

            header.addEventListener('click', toggle);
            header.addEventListener('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggle();
                }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        // Initialize countdown timer
        startCountdown();
        initCollapsibles();

        /* ========= SWIPEABLE PRODUCT GALLERY ========= */
        const thumbnails = Array.from(document.querySelectorAll('.thumbnail'));
        const mainImage = document.getElementById('currentImage');
        const mainImageWrap = document.getElementById('mainImage');
        const galleryImages = thumbnails.map(thumbnail => thumbnail.getAttribute('data-image'));
        let currentImageIndex = Math.max(0, thumbnails.findIndex(thumbnail => thumbnail.classList.contains('active')));
        let galleryAnimating = false;
        let pointerStartX = 0;
        let pointerCurrentX = 0;
        let pointerActive = false;

        function setActiveThumbnail(index) {
            thumbnails.forEach((thumbnail, i) => thumbnail.classList.toggle('active', i === index));
        }

        function showGalleryImage(index, direction = 'next') {
            if (!mainImage || !mainImageWrap || galleryAnimating || !galleryImages.length) return;

            const normalizedIndex = (index + galleryImages.length) % galleryImages.length;
            if (normalizedIndex === currentImageIndex) {
                setActiveThumbnail(normalizedIndex);
                return;
            }

            galleryAnimating = true;
            const outClass = direction === 'next' ? 'slide-out-left' : 'slide-out-right';
            const inClass = direction === 'next' ? 'slide-in-right' : 'slide-in-left';

            mainImage.classList.add(outClass);

            setTimeout(() => {
                currentImageIndex = normalizedIndex;
                mainImage.src = galleryImages[currentImageIndex];
                productData.image = galleryImages[currentImageIndex];
                setActiveThumbnail(currentImageIndex);

                mainImage.classList.remove('slide-out-left', 'slide-out-right');
                mainImage.classList.add(inClass);

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        mainImage.classList.remove('slide-in-left', 'slide-in-right');
                    });
                });

                setTimeout(() => {
                    galleryAnimating = false;
                }, 390);
            }, 220);
        }

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', function() {
                const direction = index > currentImageIndex ? 'next' : 'prev';
                showGalleryImage(index, direction);
            });
        });

        if (mainImageWrap) {
            mainImageWrap.addEventListener('pointerdown', function(event) {
                if (galleryAnimating || galleryImages.length < 2) return;
                pointerActive = true;
                pointerStartX = event.clientX;
                pointerCurrentX = event.clientX;
                mainImageWrap.classList.add('is-swiping');
                if (mainImageWrap.setPointerCapture) mainImageWrap.setPointerCapture(event.pointerId);
            });

            mainImageWrap.addEventListener('pointermove', function(event) {
                if (!pointerActive || !mainImage) return;
                pointerCurrentX = event.clientX;
                const dragX = Math.max(-90, Math.min(90, pointerCurrentX - pointerStartX));
                mainImage.style.transform = `translateX(${dragX}px) scale(0.992)`;
            });

            const finishSwipe = function(event) {
                if (!pointerActive || !mainImage) return;
                pointerActive = false;
                if (mainImageWrap.releasePointerCapture && event.pointerId !== undefined) {
                    try { mainImageWrap.releasePointerCapture(event.pointerId); } catch (error) {}
                }
                mainImageWrap.classList.remove('is-swiping');
                mainImage.style.transform = '';

                const distance = pointerCurrentX - pointerStartX;
                if (Math.abs(distance) >= 45) {
                    if (distance < 0) {
                        showGalleryImage(currentImageIndex + 1, 'next');
                    } else {
                        showGalleryImage(currentImageIndex - 1, 'prev');
                    }
                }
            };

            mainImageWrap.addEventListener('pointerup', finishSwipe);
            mainImageWrap.addEventListener('pointercancel', finishSwipe);
            mainImageWrap.addEventListener('dragstart', event => event.preventDefault());
        }

        /* ========= PUMPER-STYLE BUY 1 / 2 / 3 SELECTOR ========= */
        const buyButtons = document.querySelectorAll('.buy-button');
        buyButtons.forEach(button => {
            button.addEventListener('click', function() {
                buyButtons.forEach(item => item.classList.remove('selected'));
                this.classList.add('selected');

                currentQuantity = parseInt(this.dataset.quantity, 10) || 1;
                productData.price = this.dataset.price || '15.00';
                productData.quantity = currentQuantity;
                updateCartButtonText();
            });
        });

        /* ========= ADD TO CART BUTTON ========= */
        const addToCartBtn = document.getElementById('addToCart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', handleAddToCartClick);
            updateCartButtonText();
        }

        /* ========= WHATSAPP BUTTON FUNCTIONALITY ========= */
        const whatsappBtn = document.getElementById('whatsappButton');
        if (whatsappBtn) {
            whatsappBtn.addEventListener('click', function() {
                const message = `Hi! I'm interested in purchasing ${productData.title} from your website.\n\nProduct: ${productData.title}\nQuantity: ${currentQuantity}\nTotal: $${parseFloat(productData.price).toFixed(2)}\n\nCan you help me with the order?`;
                const encodedMessage = encodeURIComponent(message);
                this.href = `https://wa.me/96181446674?text=${encodedMessage}`;
            });
        }

        /* ========= STICKY IMAGE SCROLL (DESKTOP) ========= */
        if (window.innerWidth > 768) {
            const productImages = document.querySelector('.product-images');
            const container = document.querySelector('.product-page-container');
            const headerHeight = 80;
            
            if (productImages && container) {
                window.addEventListener('scroll', function() {
                    const scrollPosition = window.pageYOffset;
                    const containerTop = container.offsetTop;
                    const containerHeight = container.offsetHeight;
                    const windowHeight = window.innerHeight;

                    if (scrollPosition > containerTop - headerHeight) {
                        productImages.style.top = `${headerHeight}px`;

                        const distanceFromBottom = containerTop + containerHeight - (scrollPosition + windowHeight);
                        if (distanceFromBottom < 100) {
                            productImages.style.top = `calc(${windowHeight - distanceFromBottom - 100}px)`;
                        }
                    } else {
                        productImages.style.top = `${containerTop - scrollPosition + headerHeight}px`;
                    }
                });
            }
        }
    });

    /* ========= UPDATE BUTTON LABEL WITH TOTAL ========= */
    function updateCartButtonText() {
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn) return;

        const totalPrice = parseFloat(productData.price).toFixed(2);
        const labelSpan = addToCartBtn.querySelector('span');
        if (labelSpan) {
            labelSpan.textContent = `Add to Cart - $${totalPrice}`;
        }
    }

    /* ========= HANDLE ADD TO CART ========= */
    function handleAddToCartClick() {
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn) return;

        productData.quantity = parseInt(currentQuantity) || 1;

        addToCartBtn.classList.add('added');
        addToCartBtn.innerHTML = `
            <svg viewBox="0 0 24 24">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span>Adding...</span>
        `;

        const finalizeButton = (success) => {
            if (!addToCartBtn) return;

            if (success) {
                showNotification(productData.title + ' added to cart!');
                addToCartBtn.innerHTML = `
                    <svg viewBox="0 0 24 24">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span>Added to Cart</span>
                `;
                setTimeout(() => {
                    addToCartBtn.classList.remove('added');
                    addToCartBtn.innerHTML = `
                        <svg viewBox="0 0 24 24">
                            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
                        </svg>
                        <span>Add to Cart - $${parseFloat(productData.price).toFixed(2)}</span>
                    `;
                }, 2000);
            } else {
                addToCartBtn.classList.remove('added');
                updateCartButtonText();
            }
        };

        if (typeof window.addToCart === 'function') {
            try {
                const result = window.addToCart(productData.variantId, productData.quantity);
                if (result && typeof result.then === 'function') {
                    result
                        .then(() => finalizeButton(true))
                        .catch(err => {
                            console.error('Error adding to cart via global addToCart:', err);
                            finalizeButton(false);
                        });
                } else {
                    finalizeButton(true);
                }
            } catch (err) {
                console.error('Error adding to cart via global addToCart:', err);
                finalizeButton(false);
            }
        } else {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productData.variantId,
                    quantity: productData.quantity,
                    properties: {
                        '_Bundle offer': `Buy ${productData.quantity}`,
                        '_Bundle display total': `$${parseFloat(productData.price).toFixed(2)}`
                    }
                })
            })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(() => finalizeButton(true))
            .catch(err => {
                console.error('Fallback /cart/add.js error:', err);
                finalizeButton(false);
            });
        }
    }

    /* ========= TOAST NOTIFICATION ========= */
    function showNotification(message) {
        const notification = document.getElementById('cartNotification');
        const messageElement = document.getElementById('notificationMessage');
        
        if (!notification || !messageElement) return;

        messageElement.textContent = message;
        notification.style.display = 'flex';
        
        setTimeout(() => {
            notification.style.display = 'none';
        }, 3000);
    }

// Preserve the Inhale reviews-link behavior from the original product page.
document.addEventListener('DOMContentLoaded', function() {
    const reviewsLink = document.querySelector('a.rating-count[href="#inhale-reviews-section"]');
    if (!reviewsLink) return;

    reviewsLink.addEventListener('click', function(event) {
        const reviewsSection = document.getElementById('inhale-reviews-section');
        if (!reviewsSection) {
            event.preventDefault();
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }
    });
});
